import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal,
  model,
  ModelSignal,
  Signal,
  TemplateRef,
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { ProductBaseModel, ProductLabelGroup } from '@libs/shop/models';
import { ProductLinkDirective } from '@libs/shared/ui';
import { ProductCardAttributesComponent } from '../product-card-attributes';
import { ProductLabelsComponent } from '../product-labels';

@Component({
  selector: 'ui-product-card-core',
  imports: [
    ProductLabelsComponent,
    ProductLinkDirective,
    ProductCardAttributesComponent,
    MatCheckbox,
    FormsModule,
    NgTemplateOutlet,
  ],
  templateUrl: './product-card-core.component.html',
  styleUrl: './product-card-core.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCardCoreComponent {
  public product: InputSignal<ProductBaseModel> = input.required();
  public displayListView: InputSignal<boolean> = input(false);
  public showCheckbox: InputSignal<boolean> = input(false);
  public selectable: InputSignal<boolean> = input(true);
  public showAttributes: InputSignal<boolean> = input(true);
  public selected: ModelSignal<boolean> = model(false);
  public iconLabelGroups: InputSignal<ProductLabelGroup[]> = input<ProductLabelGroup[]>(['product-icons']);
  public badgeLabelGroups: InputSignal<ProductLabelGroup[]> = input<ProductLabelGroup[]>(['product-badges']);
  public enableProductClickTracking: InputSignal<boolean> = input(true);
  public position: InputSignal<number> = input(0);

  // replaces the default attribute tiles, so consumers can render their own set in the same slot
  public attributesTemplate: InputSignal<TemplateRef<unknown> | undefined> = input<TemplateRef<unknown>>();

  public wrapperClass: Signal<string> = computed(() => 'wrapper-core-' + (this.displayListView() ? 'list' : 'grid'));
}
